export const SUPPORT_EMAIL = 'support@benzinga.com';

export const PRIVACY_POLICY_URL = 'https://www.benzinga.com/privacy-policy';

export const DELETE_ACCOUNT_HREF = '/account/delete-account';

export const GOOGLE_SUBSCRIPTIONS_URL = 'https://myaccount.google.com/subscriptions';

export const passwordChangeUrl = (benzingaUid?: number): string =>
  `https://accounts.benzinga.com/password/change/${Buffer.from(`${benzingaUid}`).toString('base64')}/`;

const mailto = (subject: string, lines: string[]): string =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\r\n'))}`;

const accountLine = (email?: string): string[] => (email ? ['', `Account email: ${email}`] : []);

export const privacyRequestMailto = (email?: string): string =>
  mailto('Privacy Request', [
    'Hi Benzinga Support,',
    '',
    'I would like to exercise my privacy rights. Please process the following request:',
    '',
    '- Do not sell or share my personal data (CCPA opt-out)',
    '- Other: ____________',
    ...accountLine(email),
    '',
    'Thank you.',
  ]);

export const dataExportMailto = (email?: string): string =>
  mailto('Data Export Request', [
    'Hi Benzinga Support,',
    '',
    "I'd like to request a copy of the personal data associated with my Benzinga account.",
    ...accountLine(email),
    '',
    'Thank you.',
  ]);
